import styled from 'styled-components'

import { helpers } from 'styles'

import { Button } from './Button'

export const Container = styled.div`
	${Button}:hover & {
		border-color: ${helpers.color.primaryAccent};
	}
`
